export function formatTitle(title) {
  return title.replaceAll(" ", "-").toLowerCase()
}
